<template>
  <v-dialog v-model="value" persistent max-width="700px">
        <material-card
          color="orange"
          title="Protocol site"
          text="Import Protocol Site"
        >
          <v-form ref="form" v-model="validForm" autocomplete="off">
            <v-container py-0>
              <v-layout wrap>
              
                <v-flex xs12 md12 style="margin-top:15px">
                  <v-autocomplete
                    autocomplete="off"
                    v-model="item.protocol_id"
                    :items="protocols"
                    item-text="name"
                    item-value="id"
                    prepend-icon="mdi-clipboard-text"
                    label="Choose protocol"
                    required
                  >
                  </v-autocomplete>
                </v-flex>


                <v-flex xs12 md12>
                  <v-file-input
                    refs="file"
                    v-model="item.csv"
                    truncate-length="30"
                    label="CSV or Excel file"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    :rules="[v=>!!v || 'Csv file is required']"
                    required>
                  </v-file-input>
                </v-flex>


                <v-flex xs12 md12>

                  <pre style="font-size:10px;">
  File format : 
  ┏━━━━━━━━━━━━━━┳━━━━━━━━━━━━━━━━━┳━━━━━━━━━━━━━━┳━━━━━━━━━━━━━━━┳━━━━━━━━━━━━━━┳━━━━━━━━━━━━━┳━━━━━━━━━━━┓
  ┃    site_id   ┃ study_site_code ┃ factor_level ┃ pi_first_name ┃ pi_last_name ┃  email_pi   ┃  phone_pi ┃
  ┣━━━━━━━━━━━━━━╋━━━━━━━━━━━━━━━━━╋━━━━━━━━━━━━━━╋━━━━━━━━━━━━━━━╋━━━━━━━━━━━━━━╋━━━━━━━━━━━━━╋━━━━━━━━━━━┫
  ┃    01-059    ┃       123       ┃    fact01    ┃    Gianni     ┃   Pinotto    ┃ gp@email.it ┃ 011787787 ┃

                  </pre>

                  If study_site_code == site_id leave it blank

                </v-flex>


                <v-flex xs12 text-right>
                  
                  <v-btn
                    color="primary"
                    class="mx-1 font-weight-light"
                    @click="close()">Close</v-btn>

                  <v-btn
                    color="orange"
                    class="mx-1 font-weight-light"
                    @click="confirm"
                    :disabled="!validForm || loading"
                    :loading="loading"
                    >Confirm</v-btn>
                    
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
  </v-dialog>
</template>

<script>

import XLSX from "xlsx";
import validators from "@/utils/validators"
import {getList} from "@/api/base_entity"
import {upload as uploadProtocolSite} from "@/api/protocol_site"

export default {
  props: {
    value: { type: Boolean, default: true }
  },
  data: () => ({
    item: {},
    validForm: true,
    loading: false,
    validators,
    passwordType: 'password',
    protocols: []
  }),
  watch: {
    value(v) {
      if (v) {
        // this.$refs.form.reset()
        this.getProtocols()
      }
    },
  },
  methods: {
    close() {
      this.$emit("input", false)
    },
    getProtocols() {
      getList('protocol', {}, {rowsPerPage:-1}).then( data => {
        this.protocols = data.data
      })
    },
   
    processProtocolSiteExcel(e) {

      this.loading = true
      
      setTimeout(() => { // questo per rendere il blocco async
        const data = e.target.result;

        // Questa fottuta è bloccante
        const wb = XLSX.read(data, { type: "binary",  raw:true  });
        const first_sheet = wb.SheetNames[0];
        console.log(wb.Sheets[first_sheet])

        

        // Check !ref 
        delete wb.Sheets[first_sheet]['!margins'];
        const ref = wb.Sheets[first_sheet]['!ref'];
        delete wb.Sheets[first_sheet]['!ref'];

        const refEl = ref.split(':');
        // const refLatestRow = refEl[1].match(/(\d+)/)[0]; 
        const refLatestCol = refEl[1].replace(/[0-9]/g, '');

        const sheetKeys = Object.keys(wb.Sheets[first_sheet]);
        let maxRow = 0;

        sheetKeys.map( el => {
          if (el[0] == '!') {
            return;
          }
          try {
            var n = parseInt(el.match(/(\d+)/)[0]);
            maxRow = maxRow < n ? n : maxRow;
          } catch(e) {
            console.log(e, el)
          }
        });

        const newRef = refEl[0] + ':' + refLatestCol + maxRow;
       
        wb.Sheets[first_sheet]['!ref'] = ref;

        if ( newRef != ref) {
           const message = 'This excel appears to be corrupt, EMN Services has fix it, please check the data integrity!';
            this.$root.$emit('openSnackbar', {
              message,
              color: "error"
            });
          
          console.log('New !REF', newRef);
          wb.Sheets[first_sheet]['!ref'] = newRef;
        }

        if (sheetKeys.length > 2000000) {
          const message = "Spreadsheet is too long! Pleae verify the empty rows.";
          // this.$store.dispatch("app/openAlert", {message});
           this.$root.$emit('openSnackbar', {
            message,
            color: "error"
          });
          this.$store.dispatch("app/stopLoading");
          return;
        }

        const rows = XLSX.utils.sheet_to_json(wb.Sheets[first_sheet], {
          header: 1,
          blankRows: false,
          defval: "",
          raw:true
        });

        if (!rows.length) {
          const message = "Spreadsheet is empty!";
          // this.$store.dispatch("app/openAlert", {message});
           this.$root.$emit('openSnackbar', {
            message,
            color: "error"
          });
          this.$store.dispatch("app/stopLoading");
          return
        }

        this.item.rows = rows

        uploadProtocolSite(this.item).then( ret => {

          this.$root.$emit('openSnackbar', {
            message: "Protocol site file imported correctly, processed  " + ret.imported + ' rows.',
            color: "success"
          });
          this.$emit('imported', true);

        }) .catch( e => {

           this.$root.$emit('openSnackbar', {
            message: "An error occured during protocol site upload : " + e.response.data.message,
            color: "error"
          });
        
        }).finally( () => {
           this.loading = false
        })
        
      }, 50);
    
      
    },
    confirm() {

      const reader = new FileReader();
      reader.onload = this.processProtocolSiteExcel;
      reader.readAsBinaryString(this.item.csv);

    },
  },
}
</script>
